<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="templatesSelected"
    :clearable="!unclearable"
    :items="templatesItems"
    :loading="templatesLoading"
    :search-input.sync="templatesSearch"
    item-text="template_name"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Template.ObjectName')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :disabled="isDisabled"
  ></v-autocomplete>
</template>

<script>
import Templates from "@/api/templates";

export default {
  name: "SearcherTemplate",

  props: {
    value: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    isDisabled: Boolean,
    notDefault: Boolean,
  },

  computed: {
    templatesItems() {
      return this.templates.map((template) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == template.id
            )
          : false;
        return Object.assign({}, template, { disabled });
      });
    },
  },

  data: () => ({
    templates: [],
    templatesLoading: false,
    templatesSearch: "",
    templatesSelected: null,
  }),

  methods: {
    getTemplatesFromAPI() {
      this.templatesLoading = true;
      Templates.fetchAllForSelect()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.templates = response.data.templates;
              if (this.notDefault) {
                this.templates.splice(
                    this.templates.findIndex(
                        (template) => template.id == 0
                    ),
                    1
                )
              }
              if (this.value) {
                this.templatesSelected = this.templates.find(
                  function (template) {
                    return template.id == this.value.id;
                  }.bind(this)
                );
              } else if (this.$route.query.template_id) {
                this.templatesSelected = this.templates.find(
                  function (template) {
                    return template.id == this.$route.query.template_id;
                  }.bind(this)
                );
              }
            }
            this.templatesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.templatesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.templatesSelected = this.value;
      },
    },
    templatesSelected: {
      handler() {
        this.$emit("input", this.templatesSelected);
      },
    },
    templatesSearch: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.templates.length > 0) return; // 有结果的话不再执行
        this.getTemplatesFromAPI();
      },
    },
  },
};
</script>